/* eslint-disable import/no-unresolved */
import '@sections/index.js';

$(() => $('html').trigger('consumer.dependencies.loaded'));
